import axios from 'axios';
import Vue from 'vue';
import { get, assign, defaults, defaultsDeep, defaultTo, each, invoke, isFunction, map, reduce, replace, set, split, trim, uniqueId, toSafeInteger, countBy, filter, find, findIndex, first, has, isArray, isEmpty, isNil, isObject, isPlainObject, join, keyBy, last, max, merge, method, size, sortBy, sumBy, unset, values, castArray, cloneDeep, flow, head, invert, isEqual, isObjectLike, isString, isUndefined, keys, mapValues, once, pick } from 'lodash';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);

      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

var Response =
/*#__PURE__*/
function () {
  function Response(response) {
    _classCallCheck(this, Response);

    this.response = response;
  }

  _createClass(Response, [{
    key: "getData",
    value: function getData() {
      return get(this.response, 'data', null);
    }
  }, {
    key: "getStatus",
    value: function getStatus() {
      return get(this.response, 'status');
    }
  }, {
    key: "getHeaders",
    value: function getHeaders() {
      return get(this.response, 'headers', {});
    }
  }, {
    key: "getValidationErrors",
    value: function getValidationErrors() {
      return get(this.response, 'data', null);
    }
  }]);

  return Response;
}();

var RequestError =
/*#__PURE__*/
function () {
  function RequestError(error, response) {
    _classCallCheck(this, RequestError);

    this.error = error;
    this.response = response;
    this.stack = new Error().stack;
    this.message = error.message;
  }

  _createClass(RequestError, [{
    key: "toString",
    value: function toString() {
      return this.message;
    }
  }, {
    key: "getError",
    value: function getError() {
      return this.error;
    }
  }, {
    key: "getResponse",
    value: function getResponse() {
      return this.response;
    }
  }]);

  return RequestError;
}();

var Request =
/*#__PURE__*/
function () {
  function Request(config) {
    _classCallCheck(this, Request);

    this.config = config;
  }
  /**
   * @returns {Promise}
   */


  _createClass(Request, [{
    key: "send",
    value: function send() {
      return axios.request(this.config).then(function (response) {
        return new Response(response);
      }).catch(function (error) {
        throw new RequestError(error, new Response(error.response));
      });
    }
  }]);

  return Request;
}();

/**
 * Binds all methods of a class instance to itself.
 */
var autobind = function autobind(instance) {
  for (var obj = instance; obj; obj = Object.getPrototypeOf(obj)) {
    // We're the end of the inheritance chain if we've reached 'Object'.
    if (obj.constructor.name === 'Object') {
      return;
    }

    var names = Object.getOwnPropertyNames(obj); // Bind each function to the instance.

    for (var i = 0; i < names.length; i++) {
      var name = names[i]; // No need to bind getters, as attempting to access them would also
      // invoke them which is something we don't want to do here.

      if (Object.getOwnPropertyDescriptor(obj, name).get) {
        continue;
      } // We're using `defineProperty` here so that we don't make all the
      // class methods enumerable when we replace them.


      if (typeof obj[name] === 'function' && name !== 'constructor') {
        Object.defineProperty(instance, name, {
          value: instance[name].bind(instance),
          enumerable: false,
          configurable: true,
          writable: true
        });
      }
    }
  }
};

var REQUEST_CONTINUE = 0;
var REQUEST_REDUNDANT = 1;
var REQUEST_SKIP = 2;
/**
 * Base class for all things common between Model and Collection.
 */

var Base =
/*#__PURE__*/
function () {
  function Base(options) {
    _classCallCheck(this, Base);

    autobind(this); // Define an automatic unique ID. This is primarily to distinguish
    // between multiple instances of the same name and data.

    Object.defineProperty(this, '_uid', {
      value: uniqueId(),
      enumerable: false,
      configurable: false,
      writable: false
    });
    Vue.set(this, '_listeners', {}); // Event listeners

    Vue.set(this, '_options', {}); // Internal option store

    this.setOptions(options);
    this.boot();
  }
  /**
   * @returns {string} The class name of this instance.
   */


  _createClass(Base, [{
    key: "boot",

    /**
     * Called after construction, this hook allows you to add some extra setup
     * logic without having to override the constructor.
     */
    value: function boot() {}
    /**
     * Returns a route configuration in the form {key: name}, where key may be
     * 'save', 'fetch', 'delete' or any other custom key, and the name is what
     * will be passed to the route resolver to generate the URL. See @getURL
     *
     * @returns {Object}
     */

  }, {
    key: "routes",
    value: function routes() {
      return {};
    }
    /**
     * Returns the default context for all events emitted by this instance.
     *
     * @returns {Object}
     */

  }, {
    key: "getDefaultEventContext",
    value: function getDefaultEventContext() {
      return {
        target: this
      };
    }
    /**
     * @returns {string} Default string representation.
     */

  }, {
    key: "toString",
    value: function toString() {
      return "<".concat(this.$class, " #").concat(this._uid, ">");
    }
    /**
     * Emits an event by name to all registered listeners on that event.
      * Listeners will be called in the order that they were added. If a listener
     * returns `false`, no other listeners will be called.
     *
     * @param {string} event    The name of the event to emit.
     * @param {Object} context  The context of the event, passed to listeners.
     */

  }, {
    key: "emit",
    value: function emit(event) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var listeners = get(this._listeners, event);

      if (!listeners) {
        return;
      } // Create the context for the event.


      context = defaults({}, context, this.getDefaultEventContext()); // Run through each listener. If any of them return false, stop the
      // iteration and mark that the event wasn't handled by all listeners.

      each(listeners, function (listener) {
        return listener(context);
      });
    }
    /**
     * Registers an event listener for a given event.
     *
     * Event names can be comma-separated to register multiple events.
     *
     * @param {string}   event      The name of the event to listen for.
     * @param {function} listener   The event listener, accepts context.
     */

  }, {
    key: "on",
    value: function on(event, listener) {
      var _this = this;

      var events = map(split(event, ','), trim);
      each(events, function (event) {
        _this._listeners[event] = _this._listeners[event] || [];

        _this._listeners[event].push(listener);
      });
    }
    /**
     * @returns {Object} Parameters to use for replacement in route patterns.
     */

  }, {
    key: "getRouteParameters",
    value: function getRouteParameters() {
      return {};
    }
    /**
     * @returns {RegExp|string} Pattern to match and group route parameters.
     */

  }, {
    key: "getRouteParameterPattern",
    value: function getRouteParameterPattern() {
      return this.getOption('routeParameterPattern');
    }
    /**
     * @returns {RegExp} The default route parameter pattern.
     */

  }, {
    key: "getDefaultRouteParameterPattern",
    value: function getDefaultRouteParameterPattern() {
      return /\{([^}]+)\}/;
    }
    /**
     * @returns {Object} This class' default options.
     */

  }, {
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      return {
        // Default HTTP methods for requests.
        methods: this.getDefaultMethods(),
        // Default route parameter interpolation pattern.
        routeParameterPattern: this.getDefaultRouteParameterPattern(),
        // The HTTP status code to use for indicating a validation error.
        validationErrorStatus: 422
      };
    }
    /**
     * @param {Array|string} path     Option path resolved by `get`
     * @param {*}            fallback Fallback value if the option is not set.
     *
     * @returns {*} The value of the given option path.
     */

  }, {
    key: "getOption",
    value: function getOption(path) {
      var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return get(this._options, path, fallback);
    }
    /**
     * @returns {Object} This instance's default options.
     */

  }, {
    key: "options",
    value: function options() {
      return {};
    }
    /**
     * Sets an option.
     *
     * @param {string} path
     * @param {*}      value
     */

  }, {
    key: "setOption",
    value: function setOption(path, value) {
      set(this._options, path, value);
    }
    /**
     * Sets all given options. Successive values for the same option won't be
     * overwritten, so this follows the 'defaults' behaviour, and not 'merge'.
     *
     * @param {...Object} options One or more objects of options.
     */

  }, {
    key: "setOptions",
    value: function setOptions() {
      for (var _len = arguments.length, options = new Array(_len), _key = 0; _key < _len; _key++) {
        options[_key] = arguments[_key];
      }

      Vue.set(this, '_options', defaultsDeep.apply(void 0, [{}].concat(options, [// Given options
      this.options(), // Instance defaults
      this.getDefaultOptions() // Class defaults
      ])));
    }
    /**
     * Returns all the options that are currently set on this instance.
     *
     * @return {Object}
     */

  }, {
    key: "getOptions",
    value: function getOptions() {
      return defaultTo(this._options, {});
    }
    /**
     * Returns a function that translates a route key and parameters to a URL.
     *
     * @returns {Function} Will be passed `route` and `parameters`
     */

  }, {
    key: "getRouteResolver",
    value: function getRouteResolver() {
      return this.getDefaultRouteResolver();
    }
    /**
     * @returns {Object} An object consisting of all route string replacements.
     */

  }, {
    key: "getRouteReplacements",
    value: function getRouteReplacements(route) {
      var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var replace$$1 = {};
      var pattern = this.getRouteParameterPattern();
      pattern = new RegExp(pattern instanceof RegExp ? pattern.source : pattern, 'g');

      for (var parameter; (parameter = pattern.exec(route)) !== null;) {
        replace$$1[parameter[0]] = parameters[parameter[1]];
      }

      return replace$$1;
    }
    /**
     * Returns the default URL provider, which assumes that route keys are URL's,
     * and parameter replacement syntax is in the form "{param}".
     *
     * @returns {Function}
     */

  }, {
    key: "getDefaultRouteResolver",
    value: function getDefaultRouteResolver() {
      var _this2 = this;

      return function (route) {
        var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var replacements = _this2.getRouteReplacements(route, parameters); // Replace all route parameters with their replacement values.


        return reduce(replacements, function (result, value, parameter) {
          return replace(result, parameter, value);
        }, route);
      };
    }
    /**
     * @returns {Object} The data to send to the server when saving this model.
     */

  }, {
    key: "getDeleteBody",
    value: function getDeleteBody() {
      return {};
    }
    /**
     * @returns {Object} Query parameters that will be appended to the `fetch` URL.
     */

  }, {
    key: "getFetchQuery",
    value: function getFetchQuery() {
      return {};
    }
    /**
     * @returns {Object} Query parameters that will be appended to the `save` URL.
     */

  }, {
    key: "getSaveQuery",
    value: function getSaveQuery() {
      return {};
    }
    /**
     * @returns {Object} Query parameters that will be appended to the `delete` URL.
     */

  }, {
    key: "getDeleteQuery",
    value: function getDeleteQuery() {
      return {};
    }
    /**
     * @returns {string} The key to use when generating the `fetch` URL.
     */

  }, {
    key: "getFetchRoute",
    value: function getFetchRoute() {
      return this.getRoute('fetch');
    }
    /**
     * @returns {string} The key to use when generating the `save` URL.
     */

  }, {
    key: "getSaveRoute",
    value: function getSaveRoute() {
      return this.getRoute('save');
    }
    /**
     * @returns {string} The key to use when generating the `delete` URL.
     */

  }, {
    key: "getDeleteRoute",
    value: function getDeleteRoute() {
      return this.getRoute('delete');
    }
    /**
     * @returns {Object} Headers to use when making any request.
     */

  }, {
    key: "getDefaultHeaders",
    value: function getDefaultHeaders() {
      return {};
    }
    /**
     * @returns {Object} Headers to use when making a save request.
     */

  }, {
    key: "getSaveHeaders",
    value: function getSaveHeaders() {
      return this.getDefaultHeaders();
    }
    /**
     * @returns {Object} Headers to use when making a fetch request.
     */

  }, {
    key: "getFetchHeaders",
    value: function getFetchHeaders() {
      return this.getDefaultHeaders();
    }
    /**
     * @returns {Object} Headers to use when making a delete request.
     */

  }, {
    key: "getDeleteHeaders",
    value: function getDeleteHeaders() {
      return this.getDefaultHeaders();
    }
    /**
     * @returns {Object} Default HTTP methods.
     */

  }, {
    key: "getDefaultMethods",
    value: function getDefaultMethods() {
      return {
        fetch: 'GET',
        save: 'POST',
        update: 'POST',
        create: 'POST',
        patch: 'PATCH',
        delete: 'DELETE'
      };
    }
    /**
     * @returns {string} HTTP method to use when making a save request.
     */

  }, {
    key: "getSaveMethod",
    value: function getSaveMethod() {
      return this.getOption('methods.save');
    }
    /**
     * @returns {string} HTTP method to use when making a fetch request.
     */

  }, {
    key: "getFetchMethod",
    value: function getFetchMethod() {
      return this.getOption('methods.fetch');
    }
    /**
     * @returns {string} HTTP method to use when updating a resource.
     */

  }, {
    key: "getUpdateMethod",
    value: function getUpdateMethod() {
      return this.getOption('methods.update');
    }
    /**
     * @returns {string} HTTP method to use when patching a resource.
     */

  }, {
    key: "getPatchMethod",
    value: function getPatchMethod() {
      return this.getOption('methods.patch');
    }
    /**
     * @returns {string} HTTP method to use when creating a resource.
     */

  }, {
    key: "getCreateMethod",
    value: function getCreateMethod() {
      return this.getOption('methods.create');
    }
    /**
     * @returns {string} HTTP method to use when deleting a resource.
     */

  }, {
    key: "getDeleteMethod",
    value: function getDeleteMethod() {
      return this.getOption('methods.delete');
    }
    /**
     * @returns {number} The HTTP status code that indicates a validation error.
     */

  }, {
    key: "getValidationErrorStatus",
    value: function getValidationErrorStatus() {
      return defaultTo(this.getOption('validationErrorStatus'), 422);
    }
    /**
     * @returns {boolean} `true` if the response indicates a validation error.
     */

  }, {
    key: "isBackendValidationError",
    value: function isBackendValidationError(error) {
      // The error must have a response for it to be a validation error.
      if (!invoke(error, 'getResponse')) {
        return false;
      }

      var status = error.getResponse().getStatus();
      var invalid = this.getValidationErrorStatus();
      return status == invalid;
    }
    /**
     * @return {string|undefined} Route value by key.
     */

  }, {
    key: "getRoute",
    value: function getRoute(key, fallback) {
      var route = get(this.routes(), key, get(this.routes(), fallback));

      if (!route) {
        throw new Error("Invalid or missing route");
      }

      return route;
    }
    /**
     * @returns {string} The full URL to use when making a fetch request.
     */

  }, {
    key: "getFetchURL",
    value: function getFetchURL() {
      return this.getURL(this.getFetchRoute(), this.getRouteParameters());
    }
    /**
     * @returns {string} The full URL to use when making a save request.
     */

  }, {
    key: "getSaveURL",
    value: function getSaveURL() {
      return this.getURL(this.getSaveRoute(), this.getRouteParameters());
    }
    /**
     * @returns {string} The full URL to use when making a delete request.
     */

  }, {
    key: "getDeleteURL",
    value: function getDeleteURL() {
      return this.getURL(this.getDeleteRoute(), this.getRouteParameters());
    }
    /**
     * @param {string} route      The route key to use to generate the URL.
     * @param {Object} parameters Route parameters.
     *
     * @returns {string} A URL that was generated using the given route key.
     */

  }, {
    key: "getURL",
    value: function getURL(route) {
      var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.getRouteResolver()(route, parameters);
    }
    /**
     * @returns {Request} A new `Request` using the given configuration.
     */

  }, {
    key: "getRequest",
    value: function getRequest(config) {
      return new Request(config);
    }
    /**
     * This is the central component for all HTTP requests and handling.
     *
     * @param  {Object}     config      Request configuration
     * @param  {function}   onRequest   Called before the request is made.
     * @param  {function}   onSuccess   Called when the request was successful.
     * @param  {function}   onFailure   Called when the request failed.
     */

  }, {
    key: "request",
    value: function request(config, onRequest, onSuccess, onFailure) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        return onRequest().then(function (status) {
          switch (status) {
            case REQUEST_CONTINUE:
              break;

            case REQUEST_SKIP:
              return;

            case REQUEST_REDUNDANT:
              // Skip, but consider it a success.
              onSuccess(null);
              resolve(null);
              return;
          } // Support passing the request configuration as a function, to allow
          // for deferred resolution of certain values that may have changed
          // during the call to "onRequest".


          if (isFunction(config)) {
            config = config();
          } // Make the request.


          return _this3.getRequest(config).send().then(function (response) {
            onSuccess(response);
            resolve(response);
          }).catch(function (error) {
            onFailure(error);
            reject(error);
          }).catch(reject); // For errors that occur in `onFailure`.
        }).catch(reject);
      });
    }
    /**
     * Fetches data from the database/API.
     *
     * @param {options}             Fetch options
     * @param {options.method}      Fetch HTTP method
     * @param {options.url}         Fetch URL
     * @param {options.params}      Query params
     * @param {options.headers}     Query headers
     *
     * @returns {Promise}
     */

  }, {
    key: "fetch",
    value: function fetch() {
      var _this4 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var config = function config() {
        return defaults(options, {
          url: _this4.getFetchURL(),
          method: _this4.getFetchMethod(),
          params: _this4.getFetchQuery(),
          headers: _this4.getFetchHeaders()
        });
      };

      return this.request(config, this.onFetch, this.onFetchSuccess, this.onFetchFailure);
    }
    /**
     * Persists data to the database/API.
     *
     * @param {options}             Save options
     * @param {options.method}      Save HTTP method
     * @param {options.url}         Save URL
     * @param {options.data}        Save data
     * @param {options.params}      Query params
     * @param {options.headers}     Query headers
     *
     * @returns {Promise}
     */

  }, {
    key: "save",
    value: function save() {
      var _this5 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var config = function config() {
        return defaults(options, {
          url: _this5.getSaveURL(),
          method: _this5.getSaveMethod(),
          data: _this5.getSaveData(),
          params: _this5.getSaveQuery(),
          headers: _this5.getSaveHeaders()
        });
      };

      return this.request(config, this.onSave, this.onSaveSuccess, this.onSaveFailure);
    }
    /**
     * Converts given data to FormData for uploading.
     *
     * @param  {Object} data
     * @returns {FormData}
     */

  }, {
    key: "convertObjectToFormData",
    value: function convertObjectToFormData(data) {
      var form = new FormData();
      each(data, function (value, key) {
        form.append(key, value);
      });
      return form;
    }
    /**
     * Persists data to the database/API using FormData.
     *
     * @param {options}             Save options
     * @param {options.method}      Save HTTP method
     * @param {options.url}         Save URL
     * @param {options.params}      Query params
     * @param {options.headers}     Query headers
     *
     * @returns {Promise}
     */

  }, {
    key: "upload",
    value: function upload() {
      var _this6 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var data = defaultTo(options.data, this.getSaveData());

      var config = function config() {
        return assign(options, {
          data: _this6.convertObjectToFormData(data)
        });
      };

      return this.save(config);
    }
    /**
     * Removes model or collection data from the database/API.
     *
     * @param {options}             Delete options
     * @param {options.method}      Delete HTTP method
     * @param {options.url}         Delete URL
     * @param {options.params}      Query params
     * @param {options.headers}     Query headers
     *
     * @returns {Promise}
     */

  }, {
    key: "delete",
    value: function _delete() {
      var _this7 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var config = function config() {
        return defaults(options, {
          url: _this7.getDeleteURL(),
          method: _this7.getDeleteMethod(),
          data: _this7.getDeleteBody(),
          params: _this7.getDeleteQuery(),
          headers: _this7.getDeleteHeaders()
        });
      };

      return this.request(config, this.onDelete, this.onDeleteSuccess, this.onDeleteFailure);
    }
  }, {
    key: "$class",
    get: function get$$1() {
      return Object.getPrototypeOf(this).constructor.name;
    }
  }]);

  return Base;
}();

Base.REQUEST_CONTINUE = REQUEST_CONTINUE;
Base.REQUEST_REDUNDANT = REQUEST_REDUNDANT;
Base.REQUEST_SKIP = REQUEST_SKIP;

var ResponseError =
/*#__PURE__*/
function () {
  function ResponseError(message, response) {
    _classCallCheck(this, ResponseError);

    this.message = message;
    this.response = response;
    this.stack = new Error().stack;
  }

  _createClass(ResponseError, [{
    key: "toString",
    value: function toString() {
      return this.message;
    }
  }, {
    key: "getResponse",
    value: function getResponse() {
      return this.response;
    }
  }]);

  return ResponseError;
}();

var ValidationError =
/*#__PURE__*/
function () {
  function ValidationError(errors) {
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Model did not pass validation';

    _classCallCheck(this, ValidationError);

    this.message = message;
    this.errors = errors;
    this.stack = new Error().stack;
  }

  _createClass(ValidationError, [{
    key: "toString",
    value: function toString() {
      return this.message;
    }
  }, {
    key: "getValidationErrors",
    value: function getValidationErrors() {
      return this.errors;
    }
  }]);

  return ValidationError;
}();

var ProxyResponse =
/*#__PURE__*/
function () {
  function ProxyResponse(status) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, ProxyResponse);

    this.data = defaultTo(data, {});
    this.headers = defaultTo(headers, {});
    this.status = toSafeInteger(status);
  }

  _createClass(ProxyResponse, [{
    key: "getData",
    value: function getData() {
      return this.data;
    }
  }, {
    key: "getStatus",
    value: function getStatus() {
      return this.status;
    }
  }, {
    key: "getHeaders",
    value: function getHeaders() {
      return this.headers;
    }
  }, {
    key: "getValidationErrors",
    value: function getValidationErrors() {
      return this.data;
    }
  }]);

  return ProxyResponse;
}();

/**
* Used as a marker to indicate that pagination is not enabled.
*/

var NO_PAGE = null;
/**
 * Used as a marker to indicate that a collection has paged through all results.
 */

var LAST_PAGE = 0;
/**
 * Base collection class.
 */

var Collection =
/*#__PURE__*/
function (_Base) {
  _inherits(Collection, _Base);

  _createClass(Collection, [{
    key: "length",

    /**
     * Accessor to support Array.length semantics.
     */
    get: function get$$1() {
      return this.size();
    }
    /**
     * Creates a new instance, called when using 'new'.
     *
     * @param  {Array}  [models]    Models to add to this collection.
     * @param  {Object} [options]   Extra options to set on this collection.
     */

  }]);

  function Collection() {
    var _this;

    var models = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Collection);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Collection).call(this, options));
    Vue.set(_assertThisInitialized(_assertThisInitialized(_this)), 'models', []); // Model store.

    Vue.set(_assertThisInitialized(_assertThisInitialized(_this)), '_attributes', {}); // Property store.

    Vue.set(_assertThisInitialized(_assertThisInitialized(_this)), '_registry', {}); // Model registry.

    Vue.set(_assertThisInitialized(_assertThisInitialized(_this)), '_page', NO_PAGE);

    _this.clearState(); // Set all given attributes.


    _this.set(defaultsDeep({}, attributes, _this.defaults())); // Add all given models (if any) to this collection. We explicitly ask
    // for the values here as it's common for some sources to be objects.


    if (models) {
      _this.add(values(models));
    }

    return _this;
  }
  /**
   * Creates a copy of this collection. Model references are preserved so
   * changes to the models inside the clone will also affect the subject.
   *
   * @returns {Collection}
   */


  _createClass(Collection, [{
    key: "clone",
    value: function clone() {
      return new this.constructor(this.getModels(), this.getOptions(), this.getAttributes());
    }
    /**
     * @return {Model} The class/constructor for this collection's model type.
     */

  }, {
    key: "model",
    value: function model() {
      return this.getOption('model');
    }
    /**
     * @return {Object} Default attributes
     */

  }, {
    key: "defaults",
    value: function defaults$$1() {
      return {};
    }
    /**
     * @return {*} The value of an attribute, or a given fallback if not set.
     */

  }, {
    key: "get",
    value: function get$$1(attribute, fallback) {
      return get(this._attributes, attribute, fallback);
    }
    /**
     * Sets an attribute's value, or an object of attributes.
     *
     * @param {string|Object} attribute
     * @param {*}             value
     */

  }, {
    key: "set",
    value: function set$$1(attribute, value) {
      var _this2 = this;

      if (isPlainObject(attribute)) {
        each(attribute, function (value, key) {
          _this2.set(key, value);
        });

        return;
      }

      Vue.set(this._attributes, attribute, value);
    }
    /**
     * @return {Object}
     */

  }, {
    key: "getAttributes",
    value: function getAttributes() {
      return this._attributes;
    }
    /**
     * @return {Model[]}
     */

  }, {
    key: "getModels",
    value: function getModels() {
      return this.models;
    }
    /**
     * Returns the default options for this model.
     *
     * @returns {Object}
     */

  }, {
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      return merge(_get(_getPrototypeOf(Collection.prototype), "getDefaultOptions", this).call(this), {
        // The class/constructor for this collection's model type.
        model: Model,
        // Whether this collection should send model identifiers as JSON
        // in the body of a delete request, instead of a query parameter.
        useDeleteBody: true
      });
    }
    /**
     * @returns {Object} Parameters to use for replacement in route patterns.
     */

  }, {
    key: "getRouteParameters",
    value: function getRouteParameters() {
      return merge({}, _get(_getPrototypeOf(Collection.prototype), "getRouteParameters", this).call(this), this._attributes, {
        page: this._page
      });
    }
    /**
     * Removes all errors from the models in this collection.
     */

  }, {
    key: "clearErrors",
    value: function clearErrors() {
      each(this.models, method('clearErrors'));
    }
    /**
     * Resets model state, ie. `loading`, etc back to their initial states.
     */

  }, {
    key: "clearState",
    value: function clearState() {
      Vue.set(this, 'loading', false);
      Vue.set(this, 'saving', false);
      Vue.set(this, 'deleting', false);
      Vue.set(this, 'fatal', false);
    }
    /**
     * Removes all models from this collection.
     */

  }, {
    key: "clearModels",
    value: function clearModels() {
      var _this3 = this;

      var models = this.models; // Clear the model store, but keep a reference.

      Vue.set(this, 'models', []); // Notify each model that it has been removed from this collection.

      each(models, function (model) {
        _this3.onRemove(model);
      });
    }
    /**
     * Removes all models from this collection.
     */

  }, {
    key: "clear",
    value: function clear() {
      this.clearModels();
      this.clearState();
    }
    /**
     * Syncs all models in this collection. This method delegates to each model
     * so follows the same signature and effects as `Model.sync`.
     */

  }, {
    key: "sync",
    value: function sync() {
      each(this.models, method('sync'));
    }
    /**
     * Resets all models in this collection. This method delegates to each model
     * so follows the same signature and effects as `Model.reset`.
     *
     * @param {string|string[]} attribute
     */

  }, {
    key: "reset",
    value: function reset() {
      for (var _len = arguments.length, attribute = new Array(_len), _key = 0; _key < _len; _key++) {
        attribute[_key] = arguments[_key];
      }

      each(this.models, method.apply(void 0, ['reset'].concat(attribute)));
    }
    /**
     * Returns the number of models in this collection.
     */

  }, {
    key: "size",
    value: function size$$1() {
      return size(this.models);
    }
    /**
     * @returns {boolean} `true` if the collection is empty, `false` otherwise.
     */

  }, {
    key: "isEmpty",
    value: function isEmpty$$1() {
      return this.size() === 0;
    }
    /**
     * @returns {Object} A native representation of this collection that will
     *                   determine the contents of JSON.stringify(collection).
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.models;
    }
    /**
     * @returns {Promise}
     */

  }, {
    key: "validate",
    value: function validate() {
      return Promise.all(this.models.map(function (model) {
        return model.validate();
      }));
    }
    /**
     * Create a new model of this collection's model type.
     *
     * @param {Object} attributes
     *
     * @returns {Model} A new instance of this collection's model.
     */

  }, {
    key: "createModel",
    value: function createModel(attributes) {
      return new (this.model())(attributes);
    }
    /**
     * Removes a model from the model registry.
     *
     * @param {Model} model
     */

  }, {
    key: "removeModelFromRegistry",
    value: function removeModelFromRegistry(model) {
      unset(this._registry, model._uid);
    }
    /**
     * @return {Boolean} true if this collection has the model in its registry.
     */

  }, {
    key: "hasModelInRegistry",
    value: function hasModelInRegistry(model) {
      return has(this._registry, model._uid);
    }
    /**
     * Adds a model from the model registry.
     *
     * @param {Model} model
     */

  }, {
    key: "addModelToRegistry",
    value: function addModelToRegistry(model) {
      set(this._registry, model._uid, 1);
    }
    /**
     * Called when a model has been added to this collection.
     *
     * @param {Model} model
     */

  }, {
    key: "onAdd",
    value: function onAdd(model) {
      model.registerCollection(this);
      this.addModelToRegistry(model);
      this.emit('add', {
        model: model
      });
    }
    /**
     * Adds a model to this collection.
     *
     * This method returns a single model if only one was given, but will return
     * an array of all added models if an array was given.
     *
     * @param {Model|Array|Object} model Adds a model instance or plain object,
     *                                   or an array of either, to this collection.
     *                                   A model instance will be created and
     *                                   returned if passed a plain object.
     *
     * @returns {Model|Array} The added model or array of added models.
     */

  }, {
    key: "add",
    value: function add() {
      var model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      // If given an array, assume an array of models and add them all.
      if (isArray(model)) {
        return filter(map(model, this.add));
      } // Objects should be converted to model instances first, then added.


      if (isPlainObject(model)) {
        return this.add(this.createModel(model));
      } // This is also just to catch a potential bug. All models should have
      // an auto id so this would indicate an unexpected state.


      if (!this.isModel(model)) {
        throw new Error('Expected a model, plain object, or array of either');
      } // Make sure we don't add the same model twice.


      if (this.hasModelInRegistry(model)) {
        return;
      } // Add the model instance to this collection.


      this.models.push(model);
      this.onAdd(model); // We're assuming that the collection is not loading once a model is added.

      Vue.set(this, 'loading', false);
      return model;
    }
    /**
     * Called when a model has been removed from this collection.
     *
     * @param {Model} model
     */

  }, {
    key: "onRemove",
    value: function onRemove(model) {
      model.unregisterCollection(this);
      this.removeModelFromRegistry(model);
      this.emit('remove', {
        model: model
      });
    }
    /**
     * Removes a model at a given index.
     *
     * @param  {number} index
      * @returns {Model} The model that was removed, or `undefined` if invalid.
     * @throws  {Error} If a model could not be found at the given index.
     */

  }, {
    key: "_removeModelAtIndex",
    value: function _removeModelAtIndex(index) {
      if (index < 0) {
        return;
      }

      var model = get(this.models, index);

      Vue.delete(this.models, index);
      this.onRemove(model);
      return model;
    }
    /**
     * Removes a `Model` from this collection.
     *
     * @param  {Model} model
     *
     * @return {Model}
     */

  }, {
    key: "_removeModel",
    value: function _removeModel(model) {
      return this._removeModelAtIndex(this.indexOf(model));
    }
    /**
     * Removes the given model from this collection.
     *
     * @param  {Model|Object|Array} model Model to remove, which can be a `Model`
     *                                    instance, an object to filter by,
     *                                    a function to filter by, or an array
     *                                    of any of the above to remove multiple.
     *
     * @return {Model|Model[]} The deleted model or an array of models if a filter
     *                         or array type was given.
     *
     * @throws {Error} If the model is an invalid type.
     */

  }, {
    key: "remove",
    value: function remove(model) {
      if (!model) {
        throw new Error('Expected function, object, array, or model to remove');
      } // Support using a predicate to remove all models it returns true for.
      // Alternatively support an object of values to filter by.


      if (isFunction(model) || isPlainObject(model)) {
        return this.remove(filter(this.models, model));
      } // Support removing multiple models at the same time if an array was
      // given. A model would otherwise always be an object so this is safe.


      if (isArray(model)) {
        return filter(map(model, this.remove));
      } // This is just to catch a potential bug. All models should have
      // an auto id here so this would indicate an unexpected state.


      if (!this.isModel(model)) {
        throw new Error('Model to remove is not a valid model');
      }

      return this._removeModel(model);
    }
    /**
     * Determines whether a given value is an instance of a model.
     *
     * @param  {*} candidate A model candidate
     *
     * @return {boolean} `true` if the given `model` is an instance of Model.
     */

  }, {
    key: "isModel",
    value: function isModel(candidate) {
      return isObject(candidate) && has(candidate, '_attributes') && has(candidate, '_uid');
    }
    /**
     * Returns the zero-based index of the given model in this collection.
     *
     * @see {@link https://lodash.com/docs/#findIndex}
     *
     * @return {number} the index of a model in this collection, or -1 if not found.
     */

  }, {
    key: "indexOf",
    value: function indexOf(model) {
      var filter$$1 = model; // Getting the index of a model instance can be optimised.

      if (this.isModel(filter$$1)) {
        // Constant time check, if the registry doesn't have a record of
        // the model, we know it's not in the collection.
        if (!has(this._registry, model._uid)) {
          return -1;
        } // There is no need to filter on the entire object, because the
        // unique ID of the model is all we need to identify it.


        filter$$1 = {
          _uid: model._uid
        };
      }

      return findIndex(this.models, filter$$1);
    }
    /**
     * @param {string|function|Object} where
     *
     * @return {Model} The first model that matches the given criteria, or
     *                 `undefined` if none could be found.
     *
     * @see {@link https://lodash.com/docs/#find}
     */

  }, {
    key: "find",
    value: function find$$1(where) {
      return find(this.models, where);
    }
    /**
     * Creates a new collection of the same type that contains only the models
     * for which the given predicate returns `true` for, or matches by property.
     *
     * @see {@link where}
     *
     * Important: Even though this returns a new collection, the references to
     *            each model are preserved, so changes will propagate to both.
     *
     * @param {function|Object|string} predicate Receives `model`.
     *
     * @returns {Collection}
     */

  }, {
    key: "filter",
    value: function filter$$1(predicate) {
      var result = this.clone();
      result.models = filter(result.models, predicate);
      return result;
    }
    /**
     * Returns the models for which the given predicate returns `true` for,
     * or models that match attributes in an object.
     *
     * @see {@link https://lodash.com/docs/#filter}
     *
     * @param {function|Object|string} predicate Receives `model`.
     *
     * @returns {Model[]}
     */

  }, {
    key: "where",
    value: function where(predicate) {
      return filter(this.models, predicate);
    }
    /**
     * Returns an array that contains the returned result after applying a
     * function to each model in this collection.
     *
     * @see {@link https://lodash.com/docs/#map}
     *
     * @param {function} callback Receives `model`.
     *
     * @return {Model[]}
     */

  }, {
    key: "map",
    value: function map$$1(callback) {
      return map(this.models, callback);
    }
    /**
     * Iterates through all models, calling a given callback for each one.
     *
     * @see {@link https://lodash.com/docs/#each}
     *
     * @param {function} callback Receives `model` and `index`.
     */

  }, {
    key: "each",
    value: function each$$1(callback) {
      return each(this.models, callback);
    }
    /**
     * Reduces this collection to a value which is the accumulated result of
     * running each model through `iteratee`, where each successive invocation
     * is supplied the return value of the previous.
     *
     * If `initial` is not given, the first model of the collection is used
     * as the initial value.
     *
     * @param {function} iteratee Invoked with three arguments:
     *                            (result, model, index)
     *
     * @param {*} [initial] The initial value to use for the `result`.
     *
     * @returns {*} The final value of result, after the last iteration.
     */

  }, {
    key: "reduce",
    value: function reduce$$1(iteratee, initial) {
      // Use the first model as the initial value if an initial was not given.
      if (arguments.length === 1) {
        initial = this.first();
      }

      return reduce(this.models, iteratee, initial);
    }
    /**
     * @param {function|string} iteratee Attribute name or callback to determine
     *                                   which values to sum by. Invoked with a
     *                                   single argument `model`.
     *
     * @returns {number} Sum of all models, accessed by attribute or callback.
     */

  }, {
    key: "sum",
    value: function sum(iteratee) {
      return sumBy(this.models, iteratee);
    }
    /**
     * Returns an object composed of keys generated from the results of running
     * each model through `iteratee`. The corresponding value of each key is the
     * number of times the key was returned by iteratee.
     *
     * @see {@link https://lodash.com/docs/#countBy}
     *
     * @returns {Object}
     */

  }, {
    key: "count",
    value: function count(iteratee) {
      return countBy(this.models, iteratee);
    }
    /**
     * Sorts this collection's models using a comparator. This method performs
     * a stable sort (it preserves the original sort order of equal elements).
     *
     * @see {@link https://lodash.com/docs/#sortBy}
     *
     * @param {function|string} comparator Attribute name or attribute function,
     *                                     invoked with a single arg `model`.
     */

  }, {
    key: "sort",
    value: function sort(comparator) {
      Vue.set(this, 'models', sortBy(this.models, comparator));
    }
    /**
     * @param {Model|Object} model
     *
     * @returns {boolean} `true` if this collection contains the given model,
     *                    `false` otherwise.
     */

  }, {
    key: "has",
    value: function has$$1(model) {
      return this.indexOf(model) >= 0;
    }
    /**
     * @returns {Model|undefined} The first model of this collection.
     */

  }, {
    key: "first",
    value: function first$$1() {
      return first(this.models);
    }
    /**
     * @returns {Model|undefined} The last model of this collection.
     */

  }, {
    key: "last",
    value: function last$$1() {
      return last(this.models);
    }
    /**
     * Removes and returns the first model of this collection, if there was one.
     *
     * @returns {Model|undefined} Removed model or undefined if there were none.
     */

  }, {
    key: "shift",
    value: function shift() {
      if (!this.isEmpty()) {
        return this._removeModelAtIndex(0);
      }
    }
    /**
     * Removes and returns the last model of this collection, if there was one.
     *
     * @returns {Model|undefined} Removed model or undefined if there were none.
     */

  }, {
    key: "pop",
    value: function pop() {
      if (!this.isEmpty()) {
        return this._removeModelAtIndex(this.size() - 1);
      }
    }
    /**
     * Replaces all models in this collection with those provided. This is
     * effectively equivalent to `clear` and `add`, and will result in an empty
     * collection if no models were provided.
     *
     * @param {Model|Model[]} models Models to replace the current models with.
     */

  }, {
    key: "replace",
    value: function replace$$1(models) {
      this.clearModels();
      this.add(values(models));
    }
    /**
     * Returns the query parameters that should be used when paginating.
     *
     * @return {Object}
     */

  }, {
    key: "getPaginationQuery",
    value: function getPaginationQuery() {
      return {
        page: this._page
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getFetchQuery",
    value: function getFetchQuery() {
      if (this.isPaginated()) {
        return this.getPaginationQuery();
      }

      return _get(_getPrototypeOf(Collection.prototype), "getFetchQuery", this).call(this);
    }
    /**
     * @param {Object} response
     *
     * @returns {Array|null} Models from the response.
     */

  }, {
    key: "getModelsFromResponse",
    value: function getModelsFromResponse(response) {
      var models = response.getData(); // An empty, non-array response indicates that we didn't intend to send
      // any models in the response. This means that the current models are
      // already up to date, as no changes are necessary.

      if (isNil(models) || models === '') {
        return null;
      } // We're making an assumption here that paginated models are returned
      // within the "data" field of the response.


      if (this.isPaginated()) {
        return get(models, 'data', models);
      }

      return models;
    }
    /**
     * Called when a save request was successful.
     *
     * @param {Object} response
     */

  }, {
    key: "onSaveSuccess",
    value: function onSaveSuccess(response) {
      // Model data returned in the response.
      var saved = this.getModelsFromResponse(response); // All the models that are currently being saved.

      var saving = this.getSavingModels(); // Empty response is similar to an empty response returned when saving
      // a model: assume that the attributes are the saved state, so sync.

      if (isNil(saved)) {
        each(saving, method('sync'));
      } else {
        // There is no sensible alternative to an array here, so anyting else
        // is considered an exception that indicates an unexpected state.
        if (!isArray(saved)) {
          throw new ResponseError('Response data must be an array or empty', response);
        } // Check that the number of models returned in the response matches
        // the number of models that were saved. If these are not equal, it's
        // not possible to map saved data to the saving models.


        if (saved.length !== saving.length) {
          throw new ResponseError('Expected the same number of models in the response', response);
        } // Update every model with its respective response data.
        // A strict requirement and assumption is that the models returned
        // in the response are in the same order as they are in the collection.


        each(saved, function (data, index) {
          saving[index].onSaveSuccess(new ProxyResponse(200, data, response.getHeaders()));
        });
      }

      Vue.set(this, 'saving', false);
      Vue.set(this, 'fatal', false);
      this.emit('save', {
        error: null
      });
    }
    /**
     * @returns {Model[]} Models in this collection that are in a "saving" state.
     */

  }, {
    key: "getSavingModels",
    value: function getSavingModels() {
      return filter(this.models, 'saving');
    }
    /**
     * @returns {Model[]} Models in this collection that are in a "deleting" state.
     */

  }, {
    key: "getDeletingModels",
    value: function getDeletingModels() {
      return filter(this.models, 'deleting');
    }
    /**
     * Applies an array of validation errors to this collection's models.
     *
     * @param  {Array}   errors
     * @param  {integer} status Response status
     */

  }, {
    key: "applyValidationErrorArray",
    value: function applyValidationErrorArray(errors) {
      var models = this.getSavingModels(); // To allow matching errors with models, it's a strict requirement and
      // assumption that the array of errors returned in the response must have
      // the same number of elements as there are models being saved.

      if (errors.length !== models.length) {
        throw new ResponseError('Array of errors must equal the number of models');
      } // Set every model's errors in a way that emulates how saving a model
      // would fail in the same way.
      //
      // A strict requirement and assumption is that the models returned
      // in the response are in the same order as they are in the collection.


      each(models, function (model, index) {
        model.setErrors(errors[index]);
        Vue.set(model, 'saving', false);
        Vue.set(model, 'fatal', false);
      });
    }
    /**
     * Applies an object of validation errors keyed by model identifiers.
     *
     * @param  {Array}   errors
     * @param  {integer} status Response status
     */

  }, {
    key: "applyValidationErrorObject",
    value: function applyValidationErrorObject(errors) {
      var lookup = keyBy(this.models, function (model) {
        return model.identifier();
      });

      each(errors, function (errors, identifier) {
        var model = get(lookup, identifier);

        if (model) {
          model.setErrors(errors);
        }
      });
    }
    /**
     * Sets validation errors on this collection's models.
     *
     * @param {Array|Object} errors Either an array of length equal to the number
     *                              of models in this collection, or an object
     *                              of errors keyed by model identifiers.
     */

  }, {
    key: "setErrors",
    value: function setErrors(errors) {
      // Support an array of errors, one for each model in the collection.
      if (isArray(errors)) {
        this.applyValidationErrorArray(errors); // Support an object of errors keyed by model identifiers.
      } else if (isPlainObject(errors)) {
        this.applyValidationErrorObject(errors);
      }
    }
    /**
     * @returns {Array} An array of this collection's validation errors.
     */

  }, {
    key: "getErrors",
    value: function getErrors() {
      return map(this.models, 'errors');
    }
    /**
     * Called when a save request resulted in a validation error.
     *
     * @param {Object} response
     */

  }, {
    key: "onSaveValidationFailure",
    value: function onSaveValidationFailure(error) {
      var response = error.getResponse();
      var errors = response.getValidationErrors();

      if (!isPlainObject(errors) && !isArray(errors)) {
        throw new ResponseError('Validation errors must be an object or array', response);
      }

      this.setErrors(errors);
      Vue.set(this, 'fatal', false);
      Vue.set(this, 'saving', false);
    }
    /**
     * Called when a save request resulted in an unexpected error,
     * eg. an internal server error (500)
     *
     * @param {Error}  error
     * @param {Object} response
     */

  }, {
    key: "onFatalSaveFailure",
    value: function onFatalSaveFailure(error, response) {
      each(this.getSavingModels(), function (model) {
        model.onFatalSaveFailure(error, response);
      });

      Vue.set(this, 'fatal', true);
      Vue.set(this, 'saving', false);
    }
    /**
     * Called when a save request failed.
     *
     * @param {Error}  error
     * @param {Object} response
     */

  }, {
    key: "onSaveFailure",
    value: function onSaveFailure(error) {
      if (this.isBackendValidationError(error)) {
        this.onSaveValidationFailure(error); // Not a validation error, so something else went wrong.
      } else {
        this.onFatalSaveFailure(error);
      }

      this.emit('save', {
        error: error
      });
    }
    /**
     * @returns {Array} The data to use for saving.
     */

  }, {
    key: "getSaveData",
    value: function getSaveData() {
      return map(this.getSavingModels(), method('getSaveData'));
    }
    /**
     * Sets the page on this collection, enabling pagination. To disable
     * pagination on this collection, pass page as `null` or `undefined`.
     *
     * @param {number|boolean} [page] Page number, or `null` to disable.
     *
     * @returns {Collection} This collection.
     */

  }, {
    key: "page",
    value: function page(_page) {
      // Disable pagination if a valid page wasn't provided.
      if (isNil(_page)) {
        Vue.set(this, '_page', NO_PAGE); // Page was provided, so we should either set the page or disable
        // pagination entirely if the page is `false`.
      } else {
        Vue.set(this, '_page', max([1, toSafeInteger(_page)]));
      }

      return this;
    }
    /**
     * @returns {integer|null} The page that this collection is on.
     */

  }, {
    key: "getPage",
    value: function getPage() {
      return this._page;
    }
    /**
     * @returns {boolean} Whether this collection is currently paginated.
     */

  }, {
    key: "isPaginated",
    value: function isPaginated() {
      return this._page !== NO_PAGE;
    }
    /**
     * @returns {boolean} Whether this collection is on the last page,
     *                            ie. there won't be more results that follow.
     */

  }, {
    key: "isLastPage",
    value: function isLastPage() {
      return this._page === LAST_PAGE;
    }
    /**
     * Responsible for adjusting the page and appending of models that were
     * received by a paginated fetch request.
     *
     * @param {Model[]} models
     */

  }, {
    key: "applyPagination",
    value: function applyPagination(models) {
      // If no models were returned in the response we can assume that
      // we're now on the last page, and we should not continue.
      if (isEmpty(models)) {
        Vue.set(this, '_page', LAST_PAGE); // Otherwise, there were at least one model, and we can safely
        // assume that we want to increment the page number.
      } else {
        Vue.set(this, '_page', this._page + 1);
        this.add(models);
      }
    }
    /**
     * Called when a fetch request was successful.
     *
     * @param {Object} response
     */

  }, {
    key: "onFetchSuccess",
    value: function onFetchSuccess(response) {
      var models = this.getModelsFromResponse(response); // There is no sensible alternative to an array here, so anyting else
      // is considered an exception that indicates an unexpected state.

      if (!isArray(models)) {
        throw new ResponseError('Expected an array of models in fetch response');
      } // Append via pagination.


      if (this.isPaginated()) {
        this.applyPagination(models); // Replace all current models with the fetched ones.
      } else {
        this.replace(models);
      }

      Vue.set(this, 'loading', false);
      Vue.set(this, 'fatal', false);
      this.emit('fetch', {
        error: null
      });
    }
    /**
     * Called when a fetch request failed.
     *
     * @param {Error}  error
     */

  }, {
    key: "onFetchFailure",
    value: function onFetchFailure(error) {
      this.clearErrors();
      Vue.set(this, 'fatal', true);
      Vue.set(this, 'loading', false);
      this.emit('fetch', {
        error: error
      });
    }
    /**
     * Called before a fetch request is made.
     *
     * @returns {boolean|undefined} `false` if the request should not be made.
     */

  }, {
    key: "onFetch",
    value: function onFetch() {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        // Don't fetch if there are no more results to be fetched.
        if (_this4.isPaginated() && _this4.isLastPage()) {
          return resolve(Base.REQUEST_SKIP);
        } // Because we're fetching new data, we can assume that this collection
        // is now loading. This allows the template to indicate a loading state.


        Vue.set(_this4, 'loading', true);
        resolve(Base.REQUEST_CONTINUE);
        return;
      });
    }
    /**
     * Called when a delete request was successful.
     *
     * @param {Object} response
     */

  }, {
    key: "onDeleteSuccess",
    value: function onDeleteSuccess(response) {
      Vue.set(this, 'deleting', false);
      Vue.set(this, 'fatal', false);

      each(this.getDeletingModels(), function (model) {
        model.onDeleteSuccess(response);
      });

      this.emit('delete', {
        error: null
      });
    }
    /**
     * Called when a delete request resulted in a general error.
     *
     * @param {Error}  error
     * @param {Object} response
     */

  }, {
    key: "onDeleteFailure",
    value: function onDeleteFailure(error) {
      Vue.set(this, 'fatal', true);
      Vue.set(this, 'deleting', false);

      each(this.getDeletingModels(), function (model) {
        model.onDeleteFailure(error);
      });

      this.emit('delete', {
        error: error
      });
    }
    /**
     * Called before a save request is made.
     *
     * @returns {boolean} Either `true` or false` if the request should not be
     *                    made, where `true` indicates that the request should
     *                    be considered a "success" rather than a "cancel".
     *
     */

  }, {
    key: "onSave",
    value: function onSave() {
      var _this5 = this;

      // Don't save if we're already busy saving this collection.
      // This prevents things like accidental double clicks.
      if (this.saving) {
        return Promise.resolve(Base.REQUEST_SKIP);
      }

      var valid = true;
      var tasks = this.models.map(function (model) {
        return model.onSave().catch(function (error) {
          if (error instanceof ValidationError) {
            valid = false;
          } else {
            throw error;
          }
        });
      }); // Call 'onSave' on each model so that the models can set their state
      // accordingly, and indicate whether a validation failure should occur.

      return Promise.all(tasks).then(function () {
        if (!valid) {
          throw new ValidationError(_this5.getErrors());
        }

        Vue.set(_this5, 'saving', true);
        return Base.REQUEST_CONTINUE;
      });
    }
    /**
     * Collect all model identifiers.
     *
     * @returns {Array}
     */

  }, {
    key: "getIdentifiers",
    value: function getIdentifiers(models) {
      return map(models, method('identifier'));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getDeleteBody",
    value: function getDeleteBody() {
      if (this.getOption('useDeleteBody')) {
        return this.getIdentifiers(this.getDeletingModels());
      }

      return {};
    }
    /**
     * @returns {string} The query parameter key to use for model identifiers.
     */

  }, {
    key: "getDeleteQueryIdenitifierKey",
    value: function getDeleteQueryIdenitifierKey() {
      return 'id';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getDeleteQuery",
    value: function getDeleteQuery() {
      // Don't use query parameters if we want send the request data in the body.
      if (this.getOption('useDeleteBody')) {
        return {};
      } // Collect all the identifiers of the models being deleted.


      var models = this.getDeletingModels();
      var identifier = this.getDeleteQueryIdenitifierKey();
      var identifiers = this.getIdentifiers(models);
      return _defineProperty({}, identifier, join(identifiers, ','));
    }
    /**
     * Called before a delete request is made.
     *
     * @returns {boolean} `false` if the request should not be made.
     */

  }, {
    key: "onDelete",
    value: function onDelete() {
      var _this6 = this;

      if (this.deleting) {
        return Promise.resolve(Base.REQUEST_SKIP);
      }

      return Promise.all(this.models.map(function (m) {
        return m.onDelete();
      })).then(function () {
        // No need to do anything if no models should be deleted.
        if (isEmpty(_this6.getDeletingModels())) {
          return Base.REQUEST_REDUNDANT;
        }

        Vue.set(_this6, 'deleting', true);
        return Base.REQUEST_CONTINUE;
      });
    }
    /**
     * Convert collection to Array. All models inside are converted to JSON
     *
     * @return {object[]} converted collection
     */

  }, {
    key: "toArray",
    value: function toArray() {
      return this.map(function (model) {
        return model.toJSON();
      });
    }
  }]);

  return Collection;
}(Base);

/**
 * Reserved keywords that can't be used for attribute or option names.
 */

var RESERVED = invert(['_attributes', '_collections', '_errors', '_listeners', '_reference', '_registry', '_uid', 'attributes', 'collections', 'deleting', 'errors', 'fatal', 'loading', 'memoized', 'models', 'saving']);
/**
 * Recursive deep copy helper that honours the "clone" function of models and
 * collections. This is required to support nested instances.
 *
 * @param {Object} source
 * @param {Object} target
 * @param {Array}  keys     Optional
 */

var copyFrom = function copyFrom(source, target, keys$$1) {
  if (keys$$1) {
    source = pick(source, keys$$1);
  }

  each(source, function (value, key) {
    if (isArray(value)) {
      Vue.set(target, key, []);
      copyFrom(value, target[key]);
    } else if (isPlainObject(value)) {
      Vue.set(target, key, {});
      copyFrom(value, target[key]);
    } else if (isObject(value) && isFunction(value.clone)) {
      Vue.set(target, key, value.clone());
    } else {
      Vue.set(target, key, cloneDeep(value));
    }
  });
};
/**
 * Base model class.
 */


var Model =
/*#__PURE__*/
function (_Base) {
  _inherits(Model, _Base);

  _createClass(Model, [{
    key: "$",

    /**
     * A convenience wrapper around the model's attributes that are saved.
     * This is similar to the `saved` method, but instead of accessing a single
     * property it returns the whole saved object, so that you can do something
     * like model.$.attribute when you want to display it somewhere.
     *
     * @returns {Object} This model's saved, reference data.
     */
    get: function get$$1() {
      return this._reference;
    }
    /**
     * @returns {Object} This model's "active" state attributes.
     */

  }, {
    key: "attributes",
    get: function get$$1() {
      return this._attributes;
    }
    /**
     * @returns {Object} The collection that this model is registered to.
     */

  }, {
    key: "collections",
    get: function get$$1() {
      return values(this._collections);
    }
    /**
     * @returns {Object} This model's errors, which are cleared automatically.
     */

  }, {
    key: "errors",
    get: function get$$1() {
      return this.getErrors();
    }
    /**
     * Creates a new instance, called when using 'new'.
     *
     * @param  {Object}     [attributes]  Model attributes
     * @param  {Collection} [collection]  Collection that this model belongs to.
     * @param  {Object}     [options]     Options to set on the model.
     */

  }]);

  function Model() {
    var _this;

    var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var collection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Model);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Model).call(this, options));
    Vue.set(_assertThisInitialized(_assertThisInitialized(_this)), '_collections', {}); // Collections that contain this model.

    Vue.set(_assertThisInitialized(_assertThisInitialized(_this)), '_reference', {}); // Saved attribute state.

    Vue.set(_assertThisInitialized(_assertThisInitialized(_this)), '_attributes', {}); // Active attribute state.

    Vue.set(_assertThisInitialized(_assertThisInitialized(_this)), '_mutations', {}); // Mutator cache.

    Vue.set(_assertThisInitialized(_assertThisInitialized(_this)), '_errors', {}); // Validation errors.

    _this.clearState(); // Cache certain methods that don't need to be evaluated more than once.


    _this.memoize(); // Cache mutator pipelines so that they can run as a single function.


    _this.compileMutators(); // Assign all given model data to the model's attributes and reference.


    _this.assign(attributes); // Register the given collection (if any) to the model. This is so that
    // the model can be added to the collection automatically when it is
    // created on save, or removed on delete.


    if (collection) {
      _this.registerCollection(collection);
    }

    return _this;
  }
  /**
   * Creates a copy of this model, with the same attributes and options. The
   * clone will also belong to the same collections as the subject.
   *
   * @returns {Model}
   */


  _createClass(Model, [{
    key: "clone",
    value: function clone() {
      var attributes = {};
      var reference = {}; // Clone all attributes and their descriptors.

      copyFrom(this._attributes, attributes);
      copyFrom(this._reference, reference); // Create a copy.

      var clone = new this.constructor(); // Make sure that the clone belongs to the same collections.

      clone.registerCollection(this.collections); // Make sure that the clone has the same existing options.

      clone.setOptions(this.getOptions());
      Vue.set(clone, '_reference', reference);
      Vue.set(clone, '_attributes', attributes);
      return clone;
    }
    /**
     * Prepare certain methods to only be called once. These are methods that
     * are expected to return the same data every time.
     *
     * @see {@link https://lodash.com/docs/#once}
     */

  }, {
    key: "memoize",
    value: function memoize() {
      var _this2 = this;

      var memoized = ['validation', //   \
      'defaults', //   | These do not need to be evaluated every time.
      'routes'];
      each(memoized, function (name) {
        return _this2[name] = once(_this2[name]);
      });
    }
    /**
     * Returns the model's identifier value.
     */

  }, {
    key: "identifier",
    value: function identifier() {
      return this.get(this.getOption('identifier'));
    }
    /**
     * @returns {Object} An empty representation of this model.
     *                   It's important that all model attributes have a default
     *                   value in order to be reactive in Vue.
     */

  }, {
    key: "defaults",
    value: function defaults$$1() {
      return {};
    }
    /**
     * @returns {Object} Attribute mutations keyed by attribute name.
     */

  }, {
    key: "mutations",
    value: function mutations() {
      return {};
    }
    /**
     * Add validation rules here, or use option?
     */

  }, {
    key: "validation",
    value: function validation() {
      return {};
    }
    /**
     * Returns the default options for this model.
     *
     * @returns {Object}
     */

  }, {
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      return merge({}, _get(_getPrototypeOf(Model.prototype), "getDefaultOptions", this).call(this), {
        // The attribute that should be used to uniquely identify this model.
        identifier: 'id',
        // Whether this model should allow an existing identifier to be
        // overwritten on update.
        overwriteIdentifier: false,
        // Whether this model should perform a "patch" on update,
        // which will only send changed attributes in the request.
        patch: false,
        // Whether this model should save even if no attributes have changed
        // since the last time they were synced. If set to `false` and no
        // changes have been made, the request will be considered a success.
        saveUnchanged: true,
        // Whether this model should only use the first validation error it
        // receives, rather than an array of errors.
        useFirstErrorOnly: false,
        // Whether this model should validate an attribute that has changed.
        // This would only affect the errors of the changed attribute and
        // will only be applied if the value is not a blank string.
        validateOnChange: false,
        // Whether this model should validate models and collections within
        // its attribute tree. The result is implicit recursion as each of
        // those instances will also validate their trees, etc.
        validateRecursively: true,
        // Whether this model should mutate a property as it is changed,
        // before it is set. This is a rare requirement because you usually
        // don't  want to mutate something that you are busy editing.
        mutateOnChange: false,
        // Whether this model should mutate all attributes before they are
        // synced to the "saved" state. This would include construction,
        // on fetch, on save, and on assign.
        mutateBeforeSync: true,
        // Whether this model should use mutated values for the attributes
        // in "save" request. This will not mutate the active state.
        mutateBeforeSave: true
      });
    }
    /**
     * Compiles all mutations into pipelines that can be executed quickly.
     */

  }, {
    key: "compileMutators",
    value: function compileMutators() {
      this._mutations = mapValues(this.mutations(), function (m) {
        return flow(m);
      });
    }
    /**
     * @returns {Object} Parameters to use for replacement in route patterns.
     */

  }, {
    key: "getRouteParameters",
    value: function getRouteParameters() {
      return merge({}, _get(_getPrototypeOf(Model.prototype), "getRouteParameters", this).call(this), this._attributes);
    }
    /**
     * Registers a collection on this model. When this model is created it will
     * automatically be added to the collection. Similarly, when this model is
     * delete it will be remove from the collection. Registering the same
     * collection more than once has no effect.
     *
     * @param {Collection} collection
     */

  }, {
    key: "registerCollection",
    value: function registerCollection(collection) {
      if (isArray(collection)) {
        each(collection, this.registerCollection);
        return;
      }

      if (isNil(collection) || isUndefined(collection._uid)) {
        throw new Error('Collection is not valid');
      }

      Vue.set(this._collections, collection._uid, collection);
    }
    /**
     * Removes a collection from this model's collection registry, removing all
     * effects that would occur when creating or deleting this model.
     *
     * Unregistering a collection that isn't registered has no effect.
     *
     * @param {Collection} collection
     */

  }, {
    key: "unregisterCollection",
    value: function unregisterCollection(collection) {
      if (isArray(collection)) {
        each(collection, this.unregisterCollection);
        return;
      }

      if (isNil(collection) || isUndefined(collection._uid)) {
        throw new Error('Collection is not valid');
      }

      Vue.delete(this._collections, collection._uid);
    }
    /**
     * Reverts all attributes back to their defaults, and completely removes all
     * attributes that don't have defaults. This will also sync the reference
     * attributes, and is not reversable.
     */

  }, {
    key: "clearAttributes",
    value: function clearAttributes() {
      var defaults$$1 = this.defaults();
      Vue.set(this, '_attributes', cloneDeep(defaults$$1));
      Vue.set(this, '_reference', cloneDeep(defaults$$1));
    }
    /**
     * Reverts all attributes back to their defaults, and completely removes all
     * attributes that don't have defaults. This will also sync the reference
     * attributes, and is not reversable.
     */

  }, {
    key: "clear",
    value: function clear() {
      this.clearAttributes();
      this.clearErrors();
      this.clearState();
    }
    /**
     * Resets model state, ie. `loading`, etc back to their initial states.
     */

  }, {
    key: "clearState",
    value: function clearState() {
      Vue.set(this, 'loading', false);
      Vue.set(this, 'saving', false);
      Vue.set(this, 'deleting', false);
      Vue.set(this, 'fatal', false);
    }
    /**
     * Assigns all given model data to the model's attributes and reference.
     * This will also fill any gaps using the model's default attributes.
     *
     * @param {Object} attributes
     *
     * @returns {Object} The attributes that were assigned to the model.
     */

  }, {
    key: "assign",
    value: function assign$$1(attributes) {
      this.set(defaults({}, attributes, cloneDeep(this.defaults())));
      this.sync();
    }
    /**
     * Resets all attributes back to their reference values (source of truth).
     * A good use case for this is when form fields are bound directly to the
     * model's attributes. Changing values in the form fields will change the
     * attributes on the model. On cancel, you can revert the model back to
     * its saved, original state using reset().
     *
     * You can also pass one or an array of attributes to reset.
     *
     * @param {string|string[]} attribute
     */

  }, {
    key: "reset",
    value: function reset(attribute) {
      // Reset specific attributes.
      if (attribute) {
        copyFrom(this._reference, this._attributes, castArray(attribute)); // Reset all attributes if one or more specific ones were not given.
      } else {
        copyFrom(this._reference, this._attributes);
      }

      this.clearErrors();
      this.emit('reset');
    }
    /**
     * @returns {*} The value of an attribute after applying its mutations.
     */

  }, {
    key: "mutated",
    value: function mutated(attribute, value) {
      var mutator = get(this._mutations, attribute);

      if (mutator) {
        return mutator(value);
      }

      return value;
    }
    /**
     * Mutates either specific attributes or all attributes if none provided.
     * @param {string|string[]|undefined} attribute
     */

  }, {
    key: "mutate",
    value: function mutate(attribute) {
      var _this3 = this;

      if (isUndefined(attribute)) {
        each(this._attributes, function (value, attribute) {
          Vue.set(_this3._attributes, attribute, _this3.mutated(attribute, value));
        }); // Only mutate specific attributes.
      } else {
        each(castArray(attribute), function (attribute) {
          var current = _this3.get(attribute);

          var mutated = _this3.mutated(attribute, current);

          Vue.set(_this3._attributes, attribute, mutated);
        });
      }
    }
    /**
     * Sync the current attributes to the reference attributes. This is usually
     * only called on save. We have to clone the values otherwise we
     * end up with references to the same object in both attribute sets.
     *
     * You can also pass one or an array of attributes to sync.
     *
     * @param {string|string[]} attribute
     */

  }, {
    key: "sync",
    value: function sync(attribute) {
      var _this4 = this;

      // Mutate all attributes before we sync them, if required to do so.
      if (this.getOption('mutateBeforeSync')) {
        this.mutate(attribute);
      } // We're cloning deep to avoid multiple references to the same object,
      // otherwise updating the attributes will also update the reference.
      // Set each saved attribute to its active equivalent.


      var active = cloneDeep(this._attributes); // Sync either specific attributes or all attributes if none provided.

      if (isUndefined(attribute)) {
        Vue.set(this, '_reference', active);
      } else {
        each(castArray(attribute), function (attribute) {
          Vue.set(_this4._reference, attribute, get(active, attribute));
        });
      }

      this.emit('sync');
    }
    /**
     * Registers an attribute on this model so that it can be accessed directly
     * on the model, passing through `get` and `set`.
     */

  }, {
    key: "registerAttribute",
    value: function registerAttribute(attribute) {
      var _this5 = this;

      // Protect against unwillingly using an attribute name that already
      // exists as an internal property or method name.
      if (has(RESERVED, attribute)) {
        throw new Error("Can't use reserved attribute name '".concat(attribute, "'"));
      } // Create dynamic accessors and mutations so that we can update the
      // model directly while also keeping the model attributes in sync.


      Object.defineProperty(this, attribute, {
        get: function get$$1() {
          return _this5.get(attribute);
        },
        set: function set$$1(value) {
          return _this5.set(attribute, value);
        }
      });
    }
    /**
     * Sets the value of an attribute and registers the magic "getter" in a way
     * that is compatible with Vue's reactivity. This method should always be
     * used when setting the value of an attribute.
     *
     * @param  {string|Object}  attribute
     * @param  {*}              value
     *
     * @returns {*} The value that was set.
     */

  }, {
    key: "set",
    value: function set$$1(attribute, value) {
      var _this6 = this;

      // Allow batch set of multiple attributes at once, ie. set({...});
      if (isPlainObject(attribute)) {
        each(attribute, function (value, key) {
          _this6.set(key, value);
        });
        return;
      }

      var defined = this.has(attribute); // Only register the pass-through property if it's not already set up.
      // If it already exists on the instance, we know it has been.

      if (!defined) {
        this.registerAttribute(attribute);
      } // Current value of the attribute, or `undefined` if not set


      var previous = this.get(attribute); // Run the attribute's mutations if required to do so on change.

      if (this.getOption('mutateOnChange')) {
        value = this.mutated(attribute, value);
      }

      Vue.set(this._attributes, attribute, value); // Only consider a change if the attribute was already defined.

      var changed = defined && !isEqual(previous, value);

      if (changed) {
        this.emit('change', {
          attribute: attribute,
          previous: previous,
          value: value
        }); // Validate on change only if it's not the first time it's set.

        if (this.getOption('validateOnChange')) {
          Vue.nextTick(function () {
            return _this6.validateAttribute(attribute);
          });
        }
      }

      return value;
    }
    /**
     * Reverts all attributes back to their defaults, or `undefined` if a
     * default value is not defined.
     *
     * You can also pass one or an array of attributes to unset.
     *
     * @param {string|string[]} attribute
     */

  }, {
    key: "unset",
    value: function unset$$1(attribute) {
      var _this7 = this;

      // We're cloning deep to avoid multiple references to the same object,
      // otherwise updating the attributes will also update the reference.
      var defaults$$1 = cloneDeep(this.defaults()); // Unset either specific attributes or all attributes if none provided.

      var attributes = defaultTo(attribute, keys(this._attributes)); // Unset either specific attributes or all attributes if none provided.

      each(castArray(attributes), function (attribute) {
        if (_this7.has(attribute)) {
          Vue.set(_this7._attributes, attribute, get(defaults$$1, attribute));
        }
      });
    }
    /**
     * Similar to `saved`, returns an attribute's value or a fallback value
     * if this model doesn't have the attribute.
     *
     * @param {string} attribute
     * @param {*}      fallback
     *
     * @returns {*} The value of the attribute or `fallback` if not found.
     */

  }, {
    key: "get",
    value: function get$$1(attribute, fallback) {
      return get(this._attributes, attribute, fallback);
    }
    /**
     * Similar to `get`, but accesses the saved attributes instead.
     *
     * This is useful in cases where you want to display an attribute but also
     * change it. For example, a modal with a title based on a model field, but
     * you're also editing that field. The title will be updating reactively if
     * it's bound to the active attribute, so bind to the saved one instead.
     *
     * @param {string} attribute
     * @param {*}      fallback
     *
     * @returns {*} The value of the attribute or `fallback` if not found.
     */

  }, {
    key: "saved",
    value: function saved(attribute, fallback) {
      return get(this._reference, attribute, fallback);
    }
    /**
     * Determines if the model has an attribute.
     *
     * @param  {string}  attribute
     * @returns {boolean} `true` if an attribute exists, `false` otherwise.
     *                   Will return true if the object exists but is undefined.
     */

  }, {
    key: "has",
    value: function has$$1(attribute) {
      return has(this._attributes, attribute);
    }
    /**
     * @return {Array}
     */

  }, {
    key: "getValidateRules",
    value: function getValidateRules(attribute) {
      return castArray(get(this.validation(), attribute, []));
    }
    /**
     * Validates a specific attribute of this model, and sets errors for it.
     *
     * @returns {boolean} `true` if valid, `false` otherwise.
     */

  }, {
    key: "validateAttribute",
    value: function validateAttribute(attribute) {
      var _this8 = this;

      if (!this.has(attribute)) {
        return Promise.reject(new Error("'".concat(attribute, "' is not defined")));
      }

      var value = this.get(attribute);
      var rules = this.getValidateRules(attribute);
      var tasks = rules.map(function (rule) {
        return rule(value, attribute, _this8);
      }); // Check if any nested values should be validated also.

      if (this.getOption('validateRecursively')) {
        if (isFunction(get(value, 'validate'))) {
          tasks.push(value.validate());
        }
      }

      return Promise.all(tasks).then(function (errors) {
        // Errors will always be messages or nested error objects.
        errors = filter(errors, function (e) {
          return isString(e) || isObject(e);
        }); // Set errors for the model being validated.

        _this8.setAttributeErrors(attribute, errors); // Check to see if we should yield only the first error.


        if (_this8.getOption('useFirstErrorOnly') && !isEmpty(errors)) {
          return first(errors);
        }

        return errors;
      });
    }
    /**
     * Validates all attributes.
     *
     * @param {Object} [attributes] One or more attributes to validate.
     *
     * @returns {Promise}
     */

  }, {
    key: "validate",
    value: function validate(attributes) {
      var _this9 = this;

      if (isUndefined(attributes)) {
        attributes = Object.keys(this._attributes);
      } // Support a single, string attribute.


      if (isString(attributes)) {
        return this.validateAttribute(attributes).then(function (errors) {
          return !isEmpty(errors) ? _defineProperty({}, attributes, errors) : {};
        });
      } // Support an array of attributes to validate.


      if (isArray(attributes)) {
        var $errors = {};
        var tasks = attributes.map(function (attribute) {
          return _this9.validateAttribute(attribute).then(function (errors) {
            if (!isEmpty(errors)) {
              $errors[attribute] = errors;
            }
          });
        });
        return Promise.all(tasks).then(function () {
          return $errors;
        });
      }

      return Promise.reject(new Error("Invalid argument for validation attributes"));
    }
    /**
     * @returns {Object} A native representation of this model that will determine
     *                   the contents of JSON.stringify(model).
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return this._attributes;
    }
    /**
     * Adds this model to all registered collections.
     */

  }, {
    key: "addToAllCollections",
    value: function addToAllCollections() {
      var _this10 = this;

      each(this._collections, function (collection, id) {
        collection.add(_this10);
      });
    }
    /**
     * Removes this model from all registered collections.
     */

  }, {
    key: "removeFromAllCollections",
    value: function removeFromAllCollections() {
      var _this11 = this;

      each(this._collections, function (collection, id) {
        collection.remove(_this11);
      });
    }
    /**
     * Returns an array of attribute names that have changed, or `false` if no
     * changes have been made since the last time this model was synced.
     *
     * @returns {Array|boolean} An array of changed attribute names, or `false`
     *                         if no attributes have changed since the last sync.
     */

  }, {
    key: "changed",
    value: function changed() {
      var _this12 = this;

      var changed = [];
      each(this._attributes, function (value, attribute) {
        if (!isEqual(value, _this12.saved(attribute))) {
          changed.push(attribute);
        }
      });
      return !isEmpty(changed) ? changed : false;
    }
    /**
     * Called when a fetch request was successful.
     */

  }, {
    key: "onFetchSuccess",
    value: function onFetchSuccess(response) {
      var attributes = response.getData(); // A fetch request must receive *some* data in return.

      if (isEmpty(attributes)) {
        throw new ResponseError("No data in fetch response", response);
      }

      this.assign(attributes);
      Vue.set(this, 'fatal', false);
      Vue.set(this, 'loading', false);
      this.emit('fetch', {
        error: null
      });
    }
    /**
     * Called when a fetch request failed.
     *
     * @param {Error}  error
     */

  }, {
    key: "onFetchFailure",
    value: function onFetchFailure(error) {
      Vue.set(this, 'fatal', true);
      Vue.set(this, 'loading', false);
      this.emit('fetch', {
        error: error
      });
    }
    /**
     * @returns {string} The key to use when generating the `patch` URL.
     */

  }, {
    key: "getPatchRoute",
    value: function getPatchRoute() {
      return this.getRoute('patch', 'save');
    }
    /**
     * @returns {string} The key to use when generating the `create` URL.
     */

  }, {
    key: "getCreateRoute",
    value: function getCreateRoute() {
      return this.getRoute('create', 'save');
    }
    /**
     * @returns {string} The key to use when generating the `update` URL.
     */

  }, {
    key: "getUpdateRoute",
    value: function getUpdateRoute() {
      if (this.shouldPatch()) {
        return this.getPatchRoute();
      }

      return this.getRoute('update', 'save');
    }
    /**
     * @returns {string} The method to use when making an update request.
     */

  }, {
    key: "getUpdateMethod",
    value: function getUpdateMethod() {
      return this.shouldPatch() ? this.getPatchMethod() : _get(_getPrototypeOf(Model.prototype), "getUpdateMethod", this).call(this);
    }
    /**
     * @returns {string} The method to use when making an save request.
     */

  }, {
    key: "getSaveMethod",
    value: function getSaveMethod() {
      return this.isNew() ? this.getCreateMethod() : this.getUpdateMethod();
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getSaveRoute",
    value: function getSaveRoute() {
      if (this.isNew()) {
        return this.getCreateRoute();
      }

      return this.getUpdateRoute();
    }
    /**
     * Returns whether this model should perform a "patch" on update, which will
     * only send changed data in the request, rather than all attributes.
     *
     * @returns {boolean} Whether this model should perform a "patch" on update,
     *                    which will only send changed data in the request,
     *                    rather than all attributes.
     */

  }, {
    key: "shouldPatch",
    value: function shouldPatch() {
      return Boolean(this.getOption('patch'));
    }
    /**
     * @returns {Object} The data to send to the server when saving this model.
     */

  }, {
    key: "getSaveData",
    value: function getSaveData() {
      // Only use changed attributes if patching.
      if (this.isExisting() && this.shouldPatch()) {
        return pick(this._attributes, this.changed(), this.getOption('identifier'));
      }

      return this._attributes;
    }
    /**
     * @returns {*} A potential identifier parsed from response data.
     */

  }, {
    key: "parseIdentifier",
    value: function parseIdentifier(data) {
      return data;
    }
    /**
     * @returns {boolean} Whether the given identifier is considered a valid
     *                   identifier value for this model.
     */

  }, {
    key: "isValidIdentifier",
    value: function isValidIdentifier(identifier) {
      return Boolean(identifier);
    }
    /**
     * @returns {boolean} Whether this model allows an existing identifier to be
     *                    overwritten on update.
     */

  }, {
    key: "shouldAllowIdentifierOverwrite",
    value: function shouldAllowIdentifierOverwrite() {
      return Boolean(this.getOption('overwriteIdentifier'));
    }
    /**
     * Updates the model data with data returned from the server.
     *
     * @param {Object} response
     */

  }, {
    key: "update",
    value: function update(data) {
      // No content means we don't want to update the model at all.
      // The attributes that we passed in the request should now be considered
      // the source of truth, so we should update the reference attributes here.
      if (!data || isObjectLike(data) && isEmpty(data)) {
        this.sync(); // A plain object implies that we want to update the model data.
        // It's not a requirement to respond with a complete dataset,
        // eg. a response to a patch request might return partial data.
      } else if (isPlainObject(data)) {
        this.assign(defaults({}, data, this._attributes)); // There is some data, but it's not an object, so we can assume that the
        // response only returned an identifier for this model.
      } else {
        var identifier = this.parseIdentifier(data); // It's possible that the response didn't actually return a valid
        // identifier, so before we try to use it we should make sure that
        // we're not accidentially assigning the wrong data as identifiers.

        if (this.isValidIdentifier(identifier)) {
          // The current identifier of this model.
          var current = this.identifier(); // If an identifier already exists on this model and the returned
          // identifier is not the same, this almost definitely indicates
          // an unexpected state. The default is to protect against this
          // and fail hard, but this might not always be what we want.

          if (current && identifier !== current) {
            if (!this.shouldAllowIdentifierOverwrite()) {
              throw new Error("Not allowed to overwrite model identifier");
            }
          } // Update the identifier and sync the saved data.


          this.set(this.getOption('identifier'), identifier);
          this.sync();
        } else {
          throw new Error('Expected an empty response, object, or valid identifier');
        }
      }
    }
    /**
     * Sets errors for a specific attribute. Support the ability to clear error
     * by passing an empty value.
     *
     * @param {string}       attribute
     * @param {string|array} errors
     */

  }, {
    key: "setAttributeErrors",
    value: function setAttributeErrors(attribute, errors) {
      if (isEmpty(errors)) {
        Vue.delete(this._errors, attribute);
      } else {
        Vue.set(this._errors, attribute, castArray(errors));
      }
    }
    /**
     * Sets the errors on this model.
     *
     * @param {Object} errors
     */

  }, {
    key: "setErrors",
    value: function setErrors(errors) {
      var _this13 = this;

      if (isEmpty(errors)) {
        Vue.set(this, '_errors', {});
        return;
      }

      each(errors, function (errors, attribute) {
        _this13.setAttributeErrors(attribute, errors);
      });
    }
    /**
     * @returns {Object} Validation errors on this model.
     */

  }, {
    key: "getErrors",
    value: function getErrors() {
      if (this.getOption('useFirstErrorOnly')) {
        return mapValues(this._errors, head);
      }

      return this._errors;
    }
    /**
     * Clears all errors on this model.
     */

  }, {
    key: "clearErrors",
    value: function clearErrors() {
      this.setErrors({});
      Vue.set(this, 'fatal', false);
    }
    /**
     * Called when a save request was successful.
     *
     * @param {Object|null} response
     */

  }, {
    key: "onSaveSuccess",
    value: function onSaveSuccess(response) {
      // Clear errors because the request was successful.
      this.clearErrors(); // Update this model with the data that was returned in the response.

      if (response) {
        this.update(response.getData());
      }

      Vue.set(this, 'saving', false);
      Vue.set(this, 'fatal', false); // Automatically add to all registered collections.

      this.addToAllCollections();
      this.emit('save', {
        error: null
      });
    }
    /**
     * Called when a save request resulted in a validation error.
     *
     * @param {Object} errors
     */

  }, {
    key: "onSaveValidationFailure",
    value: function onSaveValidationFailure(error) {
      var errors = error.getResponse().getValidationErrors();

      if (!isPlainObject(errors)) {
        throw new ResponseError('Validation errors must be an object', error.getResponse());
      }

      this.setErrors(errors);
      Vue.set(this, 'fatal', false);
      Vue.set(this, 'saving', false);
    }
    /**
     * Called when a save request resulted in an unexpected error,
     * eg. an internal server error (500)
     *
     * @param {Error}  error
     * @param {Object} response
     */

  }, {
    key: "onFatalSaveFailure",
    value: function onFatalSaveFailure(error) {
      this.clearErrors();
      Vue.set(this, 'fatal', true);
      Vue.set(this, 'saving', false);
    }
    /**
     * Called when a save request resulted in a general error.
     *
     * @param {Error}  error
     * @param {Object} response
     */

  }, {
    key: "onSaveFailure",
    value: function onSaveFailure(error) {
      if (this.isBackendValidationError(error)) {
        this.onSaveValidationFailure(error);
      } else {
        this.onFatalSaveFailure(error);
      }

      this.emit('save', {
        error: error
      });
    }
    /**
     * Called when a delete request was successful.
     */

  }, {
    key: "onDeleteSuccess",
    value: function onDeleteSuccess(response) {
      this.clear();
      this.removeFromAllCollections();
      Vue.set(this, 'deleting', false);
      Vue.set(this, 'fatal', false);
      this.emit('delete', {
        error: null
      });
    }
    /**
     * Called when a delete request resulted in a general error.
     *
     * @param {Error}  error
     */

  }, {
    key: "onDeleteFailure",
    value: function onDeleteFailure(error) {
      Vue.set(this, 'deleting', false);
      Vue.set(this, 'fatal', true);
      this.emit('delete', {
        error: error
      });
    }
    /**
     * Called before a fetch request is made.
     *
     * @returns {boolean|undefined} `false` if the request should not be made.
     */

  }, {
    key: "onFetch",
    value: function onFetch() {
      var _this14 = this;

      return new Promise(function (resolve, reject) {
        // Don't fetch if already fetching. This prevents accidental requests
        // that sometimes occur as a result of a double-click.
        if (_this14.loading) {
          return resolve(Base.REQUEST_SKIP);
        }

        Vue.set(_this14, 'loading', true);
        return resolve(Base.REQUEST_CONTINUE);
      });
    }
    /**
     * @returns {boolean} whether this model is not persisted yet, ie. has not
     *                    been created yet. The default test is to check if the
     *                    model's identifier is missing.
     */

  }, {
    key: "isNew",
    value: function isNew() {
      return isNil(this.identifier());
    }
    /**
     * @returns {boolean} the opposite of `isNew`, returns `true` if this model
     *                    is already persisted somewhere else.
     */

  }, {
    key: "isExisting",
    value: function isExisting() {
      return !this.isNew();
    }
    /**
     * Called before a save request is made.
     *
     * @returns {boolean} `false` if the request should not be made.
     */

  }, {
    key: "onSave",
    value: function onSave() {
      var _this15 = this;

      return new Promise(function (resolve, reject) {
        // Don't save if we're already busy saving this model.
        // This prevents things like accidental double-clicks.
        if (_this15.saving) {
          resolve(Base.REQUEST_SKIP);
          return;
        } // Don't save if no data has changed, but consider it a success.


        if (!_this15.getOption('saveUnchanged') && !_this15.changed()) {
          resolve(Base.REQUEST_REDUNDANT);
          return;
        }

        Vue.set(_this15, 'saving', true); // Mutate attribute before we save if required to do so.

        if (_this15.getOption('mutateBeforeSave')) {
          _this15.mutate();
        }

        _this15.validate().then(function (errors) {
          if (isEmpty(errors)) {
            resolve(Base.REQUEST_CONTINUE);
            return;
          }

          Vue.set(_this15, 'saving', false);
          reject(new ValidationError(_this15.errors));
          return;
        });
      });
    }
    /**
     * Called before a delete request is made.
     *
     * @returns {boolean} `false` if the request should not be made.
     */

  }, {
    key: "onDelete",
    value: function onDelete() {
      var _this16 = this;

      if (this.deleting) {
        return Promise.resolve(Base.REQUEST_SKIP);
      }

      return new Promise(function (resolve, reject) {
        Vue.set(_this16, 'deleting', true);
        resolve(Base.REQUEST_CONTINUE);
      });
    }
  }]);

  return Model;
}(Base);

/**
 * Models and Collections for Vue.js
 *
 * @version 0.2.3
 *
 * @author Rudi Theunissen <rudi.theunissen@figured.com>
 */

export { Model, Collection };
